import { useQuery } from '@tanstack/react-query';
import { useFeatureFlags as useLibraryFeatureFlags } from '@janeapp/feature-flags-client/react';
import { initFeatureFlags } from '@janeapp/feature-flags-client';
import { FeatureFlagsApi } from '~/api';
import { getBaseUrl } from '~/env';
import { logErrorToSentry, ErrorLevel } from '~/utilities';

export const useFeatureFlags = () => {
  const { featureFlags } = useLibraryFeatureFlags();

  const { isLoading, isSuccess, isError } = useQuery({
    queryKey: ['featureFlags'],
    queryFn: async () => {
      const api = new FeatureFlagsApi({ baseUrl: getBaseUrl() });
      const response = await api.getClientConfig();
      const data = await response.json();

      await initFeatureFlags(() => Promise.resolve(data));

      return data;
    },
    retry: 1, // Retry once = 2 total attempts
    retryDelay: 1000, // 1 second delay between retries
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError(error, _query) {
      logErrorToSentry({
        type: ErrorLevel.Error,
        message: `Failed to initialize feature flags after 2 attempts: ${error}`,
      });
      return false;
    },
  });

  return {
    featureFlags,
    isLoading,
    isSuccess,
    isError,
  };
};
